import { Turbo } from '@hotwired/turbo-rails'
import '@/v2/controllers'
import '@/v2/lexxy'
import { reconcileCacheOwner } from '@/v2/cache-owner'

reconcileCacheOwner(document.body.dataset.posthogUserIdValue)

addEventListener('turbo:before-morph-element', (e) => {
  const { target } = e

  if (target.tagName.startsWith('LEXXY-') || target.tagName.startsWith('CANVAS')) {
    e.preventDefault()
  }
})

addEventListener('turbo:before-morph-attribute', (e) => {
  const { target, detail: { attributeName, mutationType } } = e

  // When a popover element is morphed into a new element, close the popover so that it is removed from the top-layer
  if (target.hasAttribute('popover') && attributeName === 'id' && mutationType === 'update') {
    target.hidePopover()
  }

  // Dialog elements do not receive close() when their open attribute is removed, so they must be
  // explicitly removed from the top-layer when this happens via morph.
  // https://github.com/hotwired/turbo/issues/1239
  if (target instanceof HTMLDialogElement && attributeName === 'open' && mutationType === 'remove') {
    e.preventDefault()
    target.close()
  }
})

// Handle custom redirect event to bust out of turboframes
Turbo.StreamActions.redirect = function () {
  document.querySelector<HTMLDialogElement>('dialog[open]')?.close()
  Turbo.visit(this.target)
}

Turbo.StreamActions.close_modal = () => {
  document.querySelector<HTMLDialogElement>('dialog[open]')?.close()
}
